module.exports = __webpack_public_path__ + "img/groupBuy.1fc563b5.webp";